export default __webpack_public_path__ + "static/feature-importances-sales--mobile-36d184b0e30fbdeaee01c09c1c1bd859.webp";